
<template>
  <v-layout v-if="balancePermissions['manage-balance']" class="grey lighten-4" column>
    <v-toolbar :flat="true" color="transparent">
      <v-toolbar-title class="blue-grey--text darken-1 headline font-weight-bold">
        Administrar saldo de {{ restaurant.name }}
      </v-toolbar-title>
    </v-toolbar>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
    <v-flex xs12>
      <v-row>
        <v-col>
          <v-card height="100%" width="30%">
            <v-card-title class="blue-grey darken-1 white--text pa-2 overline">
              <div class="d-flex pa-1">
                  Saldo disponible
              </div>
            </v-card-title>
            <v-card-text class="text-center">
              <div class="headline pa-2">
                <v-skeleton-loader
                  v-if="isLoading"
                  class="pa-2"
                  type="text"
                />
                <span v-else data-cy="amountAvailable">
                  ${{ (detail.balance || {}).amountAvailable | toFixNumber(2) | numberWithComma }} {{ (detail.balance || {}).currency }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-switch
        v-model="isActive"
        inset
        color="primary"
        :label="switchLabel"
      >
      </v-switch>
      <v-dialog @keydown.esc="dialog=false" v-model="dialog" persistent width="500">
        <v-card>
          <v-card-title>Desactivar administración de saldo</v-card-title>
          <v-card-text>
            ¿Está seguro de que desea desactivar la administración de su saldo?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="cancel">Cancelar</v-btn>
            <v-btn color="primary" @click="deactivateManageBalance">Desactivar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row v-if="isActive">
        <v-col>
          <ManageBalance
            v-if="balancePermissions['manage-balance']"
          />
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
  <v-layout v-else>
    <v-flex xs12>
      <v-card>
        <v-card-title>Error 403: Acceso denegado</v-card-title>
        <v-card-text>
          No tienes los permisos necesarios para acceder a esta página.
        </v-card-text>
        <v-card-actions>
          <router-link to="/">Volver a la página principal</router-link>
        </v-card-actions>
      </v-card>
  </v-flex>
  </v-layout>
</template>

<script>
import Balance from '@/models/Balance'
import Restaurant from '@/models/Restaurant'
import ManageBalance from '@/components/tables/ManageBalance'

export default {
  name: 'Balance',
  components: {
    ManageBalance
  },
  data () {
    const balanceModel = new Balance({ restaurant: this.restaurant })
    const restaurantModel = new Restaurant()
    return {
      isActive: false,
      dialog: false,
      snackbar: false,
      loading: false,
      snackbarText: '',
      restaurantModel,
      balanceModel,
      detail: {}
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    balancePermissions () {
      return this.$store.state.login.permissions['my-management'].components['add-balance'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    switchLabel () {
      return this.isActive ? 'Activado' : 'Desactivado'
    }
  },
  watch: {
    restaurant: {
      handler: 'load',
      immediate: true,
      async: true
    },
    isActive (newVal, _oldVal) {
      if (!this.loading && newVal !== undefined && !newVal) {
        this.dialog = true
      }
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    cancel () {
      this.isActive = true
      this.dialog = false
    },
    async deactivateManageBalance () {
      this.dialog = false
      try {
        await this.$api.post(`/v1/restaurants/${this.restaurant._id}/balance/manage/deactivate`)
        this.snackbar = true
        this.snackbarText = 'Se ha desactivado correctamente la administración de saldo'
        this.isActive = false
      } catch (error) {
        this.snackbar = true
        this.snackbarText = error.message
      }
    },
    async load () {
      this.loading = true
      this.dialog = false
      this.snackbarText = ''
      this.$store.commit('changeLoading', true)
      try {
        this.restaurantModel.set(this.restaurant)
        const res = await this.restaurantModel.detail()
        this.detail = res.response.data
        if (res.response.data.balance) {
          this.isActive = res.response.data.balance.manageBalanceIsActive
          this.$store.commit('setAmountAvailable', res.response.data.balance.amountAvailable)
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.$store.commit('changeLoading', false)
      this.loading = false
    }
  }
}
</script>
